import Swiper, {Navigation, Lazy} from "swiper";
import {MD_WIDTH, LG_WIDTH, XL_WIDTH} from "@main/helpers/const";
/** Класс слайдера в статье/новости */ 
class ArticleSlider {
    /**
     * Создает компонент.
     *
     * @param {HTMLElement} el Элемент слайдера в статье/новости.
     */
    constructor(el) {
        this.el = el;
        this.sliderContainer = this.el.querySelector(".js-article-slider-container");
        this.prevButton = this.el.querySelector(".js-article-prev");
        this.nextButton = this.el.querySelector(".js-article-next");
        this.addCounterToFirstSlide();
        this.createArticleSlider();
    }

    /**
     * Инициализация слайдера.
     * 
     * @returns {void}
     */
    createArticleSlider() {
        const swiper = new Swiper(this.sliderContainer, {
            modules: [Lazy, Navigation],
            slidesPerView: "auto",
            preloadImages: false,
            lazy: {
                loadPrevNext: true,
                loadPrevNextAmount: 2,
            },
            spaceBetween: 8,
            breakpoints: {
                [MD_WIDTH]: {
                    spaceBetween: 16,
                    lazy: {
                        loadPrevNext: true,
                        loadPrevNextAmount: 4,
                    },
                },
                [LG_WIDTH]: {
                    spaceBetween: 16,
                    lazy: {
                        loadPrevNext: true,
                        loadPrevNextAmount: 4,
                    },
                },
                [XL_WIDTH]: {
                    spaceBetween: 15,
                    lazy: {
                        loadPrevNext: true,
                        loadPrevNextAmount: 5,
                    },
                },
            },
            navigation: {
                nextEl: this.nextButton,
                prevEl: this.prevButton,
            },
        });

        swiper.on("slideChangeTransitionEnd", (swiper) => {
            const slideCounter = swiper.slides[swiper.activeIndex].querySelector(".js-article-slider-counter");
            slideCounter.innerText = `${swiper.activeIndex + 1} / ${swiper.slides.length}`;
        });
    }

    /**
     * Добавление дробной разбивки на страницы для первого слайда.
     * 
     * @returns {void}
     */
    addCounterToFirstSlide() {
        const sliderWrapper = this.sliderContainer.firstElementChild;
        const firstSlide = sliderWrapper.firstElementChild;
        const slideCounter = firstSlide.querySelector(".js-article-slider-counter");
        const lengthAllSliders = sliderWrapper.children.length;

        slideCounter.innerText = `1 / ${lengthAllSliders}`;
    }
}

document.querySelectorAll(".js-article-slider").forEach((slider) => new ArticleSlider(slider));
